import React from "react";
import SummaryDetailsTravel from "./ContractSpecificDetails/SummaryDetailsTravel";
import SummaryDetailsPurchase from "./ContractSpecificDetails/SummaryDetailsPurchase";
import SummaryDetailsVehicle from "./ContractSpecificDetails/SummaryDetailsVehicle";
import SummaryDetailsSubscription from "./ContractSpecificDetails/SummaryDetailsSubscription";
import SummaryDetailsMembership from "./ContractSpecificDetails/SummaryDetailsMembership";
import SummaryDetailsService from "./ContractSpecificDetails/SummaryDetailsService";
import SummaryDetailsEvent from "./ContractSpecificDetails/SummaryDetailsEvent";
import SummaryDetailsProvider from "./ContractSpecificDetails/SummaryDetailsProvider";
import { Box } from "@mui/material";
import SummaryDetailsDataLeak from "./ContractSpecificDetails/SummaryDetailsDataLeak";

interface SummaryContractDetailsProps {
  caseData: {
    name: string;
  };
}

const SummaryContractDetails = ({ caseData }: SummaryContractDetailsProps) => {
  function getContractDetails(caseData: any) {
    switch (caseData.name) {
      case "travelContract":
        return <SummaryDetailsTravel caseData={caseData} />;
      case "purchaseContract":
        return <SummaryDetailsPurchase caseData={caseData} />;
      case "vehicleContract":
        return <SummaryDetailsVehicle caseData={caseData} />;
      case "subscriptionContract":
        return <SummaryDetailsSubscription caseData={caseData} />;
      case "membershipContract":
        return <SummaryDetailsMembership caseData={caseData} />;
      case "serviceContract":
        return <SummaryDetailsService caseData={caseData} />;
      case "eventContract":
        return <SummaryDetailsEvent caseData={caseData} />;
      case "providerContract":
        return <SummaryDetailsProvider caseData={caseData} />;
      case "dataLeakContract":
        return <SummaryDetailsDataLeak caseData={caseData} />;
      default:
        return null;
    }
  }

  return (
    <>
      <Box id={"contractDetails"} />
      {getContractDetails(caseData)}
    </>
  );
};

export default SummaryContractDetails;
